import React, { Component } from 'react';
import { Icon } from 'antd';
import { Link } from "react-router-dom"
export default class Newsblog extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}


	extactTag = (str) => this.cuttext(str.replace(/<[^>]*>/g, ''), 100)
	cuttext(text, maxlength) {
		if (text.length > maxlength) {
			var newtext = text.slice(0, maxlength);
			newtext += "..."
			return newtext
		} else return text
	}
	render() {
		const { lists } = this.props
		return (
			<div>
				<div className="our-blog">
					<div className="container">
						<div className="theme-title">
							<h2>Recent News</h2>
							<Link to="/blog" className="tran3s">Go to News</Link>
						</div>
						<div className="row">
							{lists.slice(0, 3).map((list, key) => (
								<div key={key} className="col-md-4 col-sm-6">
									<div className="single-blog">
										<div className="image"><img src={list.image} alt={list.title} /></div>
										<ul>
											<li>
												<i className="flaticon-comments"></i>
												<a href="#" className="tran3s">{list.commentsNo}</a>
											</li>
											<li>
												<i className="flaticon-heart"></i>
												<a href="#" className="tran3s">{list.likes}</a>
											</li>
										</ul>
										<h4><Link to={`/blog/${list.slug}`} className="tran3s">{list.title}</Link></h4>
										{/* <p>{this.extactTag(list.content)}</p> */}
										<p dangerouslySetInnerHTML={{ __html: list.content.substring(0, 150) + '...' }}></p>
										<Link to={'/blog/' + list.slug} className="tran3s">Read More</Link>
									</div>
								</div>
							))}

						</div>
					</div>
				</div>


			</div>
		)
	}
}
